export class ClientError extends Error {
  constructor(message: string = 'A client side error occurred.') {
    super(message)
    Object.setPrototypeOf(this, ClientError.prototype)
  }
}
